import { Node } from 'reactflow';
import { v4 as uuidv4 } from 'uuid';

import { FLOW_TYPE } from 'constants/flow';

export const getNodeId = (name: string) => {
  return `${name}_${uuidv4()}`;
};

export const checkDataNodeExist = (nodes: Node[]) => {
  const dataNodes = nodes.filter((node) => node.type === FLOW_TYPE.NODE.DATA_NODE);

  return dataNodes.length > 0;
};
